import { Button, InlineStack, Paragraph } from '@customerio/pluma-components/react';
import plur from 'plur';

/**
 * What is being edited, and the one Save that ends it.
 *
 * Its own bar rather than the table's bulk-actions header: editing several
 * rows turns row selection off, and that header only appears while rows are
 * selected.
 */

export type BulkEditBarProps = {
  count: number;
  /** What the rows are called: "attribute" or "event". */
  noun: string;
  isSaving: boolean;
  /** Whether a cell is still naming a tag the save has to include. */
  isNaming: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export function BulkEditBar({ count, noun, isSaving, isNaming, onSave, onCancel }: BulkEditBarProps) {
  return (
    <InlineStack alignBlock="center" alignInline="space-between" gap="200">
      <Paragraph size="sm">
        Bulk editing {count} {plur(noun, count)}
      </Paragraph>
      <InlineStack gap="200">
        <Button variant="secondary" size="sm" isDisabled={isSaving} onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" size="sm" isDisabled={isNaming} isLoading={isSaving} onClick={onSave}>
          Save
        </Button>
      </InlineStack>
    </InlineStack>
  );
}
